import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData,
  type ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError,
  type ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse,
  exchangeTokenV1OrganizationsOrganizationIdAuthorizePost,
} from '../../generated';

export type ExchangeTokenMutationVariables = ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData['path'];

export type ExchangeTokenMutation = ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse;

export const useExchangeTokenMutation = <
  TError = ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<ExchangeTokenMutation, TError, ExchangeTokenMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<ExchangeTokenMutation, TError, ExchangeTokenMutationVariables, TContext>({
    mutationKey: ['ExchangeToken'],
    mutationFn: async ({ organization_id }: ExchangeTokenMutationVariables) => {
      const { data } = await exchangeTokenV1OrganizationsOrganizationIdAuthorizePost({
        path: { organization_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useExchangeTokenMutation.fetcher = (
  { organization_id }: ExchangeTokenMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await exchangeTokenV1OrganizationsOrganizationIdAuthorizePost({
      path: { organization_id },
      throwOnError: true,
    });
    return data;
  };
};
